import { render, staticRenderFns } from "./CardUserTop.vue?vue&type=template&id=5e83cef6&scoped=true&"
import script from "./CardUserTop.vue?vue&type=script&lang=js&"
export * from "./CardUserTop.vue?vue&type=script&lang=js&"
import style0 from "./CardUserTop.vue?vue&type=style&index=0&id=5e83cef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83cef6",
  null
  
)

export default component.exports